import { Intent } from '../intent';
export interface InitStoreType {
  agentAvatar: string;
  botNickname: string;
  sessionId: string;
  lastMessageContent: string;
  isPremiumUser: boolean;
  shortcutType: SHORTCUT_TYPE;
  chatbotType: number;
  grayFeatures: [
    {
      name: 'typing auto-suggestion';
      line: number;
    }
  ];
  isIOS: boolean;
  from: string;
  pageBeforeHc: string;
  abTestSignature: string;
  UPDATE_DONT_SCROLL_TO_BOTTOM: (dontScrollToBottom: boolean) => void;
  UPDATE_SHORTCUT_INTENTS: (shortcutIntents: Intent[]) => void;
  UPDATE_INTENT_PREDICTION_SHORTCUT_IF_ALLOWED: (shortcutIntents: Intent[]) => void;
  isPremium: boolean;
}

export enum SHORTCUT_TYPE {
  ConfiguredShortcut,
  IntentShortcut,
}
